import React from 'react';
import Camera, {FACING_MODES, IMAGE_TYPES} from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import postData from "../service/fetcher";

class Cam extends React.Component {

    handleTakePhoto(dataUri) {
        this.setState({taken: this.state.taken + 1}, () => {
                postData("/api/Cam", {token: this.props.token}, {
                    image: dataUri,
                    id: this.state.id
                })[0].then((d) => {
                    if (d !== undefined && d.upload === "success") this.setState({uploaded: this.state.uploaded + 1});
                    else this.setState({failed: this.state.failed + 1});
                }).catch(() => this.setState({failed: this.state.failed + 1}));
            }
        );

    }

    componentDidMount() {
        this.setState({id: this.props.id});
        document.getElementById("headd").style.display = "none";
        document.getElementById("foott").style.display = "none";
    }

    componentWillUnmount() {
        document.getElementById("headd").style.display = "block";
        document.getElementById("foott").style.display = "block";
    }

    state = {taken: 0, uploaded: 0, failed: 0};

    render() {
        return (
            <div className={"nooverflow"}>
                <Camera
                    onTakePhoto={(dataUri) => this.handleTakePhoto(dataUri)}
                    idealFacingMode={FACING_MODES.ENVIRONMENT}
                    isFullScreen={true}
                    imageType={IMAGE_TYPES.JPG}
                    imageComprehension={0.70}
                    isImageMirror={false}
                    isMaxResolution={true}
                />
                <div className={"floatCam"}>
                    <button onClick={() => this.props.page("folder", this.state.id)}>Go Back</button>
                    <br/>
                    <p>{this.state.uploaded} geupload van de {this.state.taken}.
                        Waarvan {this.state.failed} gefaald.</p>
                </div>
            </div>
        );
    }
}

export default Cam;
